import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=3f24e09a&scoped=true&"
import script from "./introduction.vue?vue&type=script&lang=js&"
export * from "./introduction.vue?vue&type=script&lang=js&"
import style0 from "./introduction.vue?vue&type=style&index=0&id=3f24e09a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f24e09a",
  null
  
)

export default component.exports